export default 'SET_BANNER';




// WEBPACK FOOTER //
// ./src/shared/components/banner/store/types.js